<template>
	<div>
		<SchedulerEvents v-if="idUser"/>
	</div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import SchedulerEvents from '@/components/scheduler/SchedulerEvents'
import Forbidden from '@/components/403/Forbidden'

export default {
	components: {
		SchedulerEvents,
		Forbidden
	},
	async mounted(){
		if (this.idUser != null && this.idUser != ""){
			const r = await this.fetchPermissionsUser( this.idUser)
			this.setPermissionsUser(r?.permissions || [])
		}
		// console.log(r.permissions)
	},
	computed:{
		...mapState('init',['idUser']),
	},
	methods:{
		...mapActions('init',['fetchPermissionsUser']),
		...mapMutations('init',['setPermissionsUser']),
	}
}
</script>
<style>
	@import '~@/assets/css/styles.css';  /*estilos */
</style>